var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-fullheight is-dark",attrs:{"id":"home"}},[_c('Head'),_c('Body'),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }